import { render, staticRenderFns } from "./gsr_stxh_report.vue?vue&type=template&id=5034140c&scoped=true"
import script from "./gsr_stxh_report.vue?vue&type=script&lang=js"
export * from "./gsr_stxh_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034140c",
  null
  
)

export default component.exports